import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CheckMarketOpenClose from '../utils/MarketOpenClose/Check-Market-Open';
import { CheckStoreWebOpen } from '../utils/Store/StoreCheck';

const useStoreStatus = () => {
    const dispatch = useDispatch();
    const selectedStore = useSelector((state: any) => state?.store?.selectedStore)
    // console.log("_selectedStore",selectedStore)


    const isStoreWebOpen = useMemo(() => {
        return CheckStoreWebOpen(selectedStore);
    }, [selectedStore])


    const marketData = useMemo(() => {
        return CheckMarketOpenClose(selectedStore?.store_available, selectedStore?.store_setting?.pre_order_status);
    }, [selectedStore])

    const storeDeliveryPickupType = useSelector((state: any) => state.store.storeDeliveryPickupType);

    const returnIsStoreClose = useMemo(() => {
        return isStoreWebOpen || Object.keys(marketData)?.length == 0 || storeDeliveryPickupType?.isPickupNDelivery == false;
    }, [marketData, isStoreWebOpen, storeDeliveryPickupType, selectedStore])



    return { returnIsStoreClose,isStoreWebOpen, preOrder: marketData?.pre, store_timing: marketData?.data, marketData: marketData }
}

export default useStoreStatus